<form
  #form="ngForm"
  data-ping-host
  novalidate
>
  <h1 class="mb-4 justify-self-center text-xl">Bunkering</h1>

  <div class="flex justify-end pb-6">
    <re-fuel-oil-bunkers />
  </div>

  <div
    id="fuelOilBunkerTable"
    class="flex w-full flex-col gap-1"
  >
    <div class="flex w-full flex-row">
      @for (heading of HEADINGS; track heading) {
        <nsp-input-label
          [label]="heading"
          class="flex-1 px-2"
          alignment="center"
          [required]="isFieldRequired(FIELDS[$index])"
        />
      }
      <div class="w-4"></div>
    </div>

    @let state = offshoreBunkerStore.fuelOilBunkerTable();
    @let vm = offshoreBunkerStore.bunkerTableVm();
    @let fuelSpecsVm = fuelSpecsStore.fuelspecsVm();

    @for (bunkerRow of state.bunkerRows; track bunkerRow.rowId.value) {
      @let rowIndex = $index;
      @if (bunkerRow) {
        @let row = state.bunkerRows[rowIndex];
        @let fuelTypeCode = getFuelTypeCode(row.fuelType.value);
        @let rowIsEditable = !!row.fuelType.value;
        @let rowLimits = vm.getRowMinMax(rowIndex);
        @let fuelTypeIsReadOnly = vm.isFuelTypeReadOnly(rowIndex);
        <div class="flex w-full flex-row gap-1 text-base">
          @for (field of FIELDS; track field) {
            <div class="flex min-w-0 flex-1">
              @let fieldId = `bunkerRows-${field}-${rowIndex}`;
              @if (field === 'fuelType') {
                <nsp-select-input
                  [id]="`bunkerRows-fuelType-${rowIndex}`"
                  [name]="`bunkerRows-fuelType-${rowIndex}`"
                  [options]="vm.getFuelTypeOptions(rowIndex)"
                  [readonly]="fuelTypeIsReadOnly"
                  [showClear]="true"
                  [value]="row.fuelType.value"
                  [ngModel]="row.fuelType.value"
                  (cleared)="onFuelTypeCleared(rowIndex)"
                  (ngModelChange)="onFuelTypeChange($event, rowIndex)"
                />
              } @else if (field === 'isoFuelGrade') {
                <nsp-select-input
                  [id]="`bunkerRows-isoFuelGrade-${rowIndex}`"
                  [name]="`bunkerRows-isoFuelGrade-${rowIndex}`"
                  [pTooltip]="
                    vm.shouldShowInvalidTooltip(row.isoFuelGrade, rowIsEditable)
                      ? vm.getInvalidTooltip(
                          'isoFuelGrade',
                          fuelTypeCode,
                          rowLimits
                        )
                      : undefined
                  "
                  tooltipPosition="top"
                  tooltipStyleClass="text-white"
                  [showClear]="true"
                  [options]="getIsoGradeOptions(row.fuelType.value)"
                  [required]="rowIsEditable && isRequired(field)"
                  [readonly]="!rowIsEditable"
                  [value]="row.isoFuelGrade.value"
                  [ngModel]="row.isoFuelGrade.value"
                  (cleared)="
                    clearBunkerRow(rowIndex, ['fuelType', 'isoFuelGrade'])
                  "
                  (ngModelChange)="
                    onFuelISOGradeChange(rowIndex, row.fuelType.value, $event)
                  "
                />
              } @else {
                @let fieldType = FIELD_TYPE_MAP[field];
                @switch (fieldType) {
                  @case ('number') {
                    @let fieldLimits =
                      fuelSpecsVm.getFieldLimits(field, rowLimits);
                    <nsp-number-input
                      [id]="fieldId"
                      [name]="fieldId"
                      [required]="rowIsEditable && isRequired(field)"
                      [readonly]="!rowIsEditable"
                      [ngModel]="row[field].value"
                      [min]="fieldLimits.min"
                      [max]="fieldLimits.max"
                      [maxFractionDigits]="3"
                      [pTooltip]="
                        vm.shouldShowInvalidTooltip(row[field], rowIsEditable)
                          ? vm.getInvalidTooltip(field, fuelTypeCode, rowLimits)
                          : field === 'quantityReceived' && rowIsEditable
                            ? vm.getQuantityReceivedWarning(
                                fuelTypeCode,
                                row.quantityReceived.value
                              )
                            : rowIsEditable
                              ? vm.getWarningTooltip(field, fuelTypeCode)
                              : undefined
                      "
                      tooltipPosition="top"
                      tooltipStyleClass="text-white"
                    />
                  }
                  @case ('text') {
                    @let value = asString(row[field].value);
                    <nsp-text-input
                      [pTooltip]="
                        vm.shouldShowInvalidTooltip(row[field], rowIsEditable)
                          ? vm.getInvalidTooltip(field, fuelTypeCode, rowLimits)
                          : undefined
                      "
                      tooltipPosition="top"
                      tooltipStyleClass="text-white"
                      [id]="fieldId"
                      [name]="fieldId"
                      [required]="rowIsEditable && isRequired(field)"
                      [readonly]="!rowIsEditable"
                      [value]="value"
                      [ngModel]="row[field].value"
                    />
                  }
                }
              }
            </div>
          }

          <p-button
            data-testid="remove-bunker-row-button"
            (onClick)="removeBunkerRow(rowIndex)"
            variant="text"
            class="-mr-7.5 inline-flex items-center justify-center opacity-60 transition-opacity hover:opacity-100"
            styleClass="h-full w-2.5 min-w-0 rounded-sm!"
            [class.invisible]="state.bunkerRows.length <= 1"
          >
            <nsp-icon
              [name]="IconNames.TrashAlt"
              class="inline-flex w-2.5 items-center justify-center text-red-500"
            />
          </p-button>
        </div>
      }
    }
  </div>
</form>

<div class="mt-2 w-full text-center">
  <p-button
    variant="text"
    (onClick)="addBunkerRow()"
    data-testid="add-bunker-row-button"
  >
    <nsp-icon
      [name]="IconNames.Plus"
      class="mr-2 text-green-600"
    />
    <span> Add a bunker</span>
  </p-button>
</div>
